import React from "react";
import StudentNotifications from "@/pages/student/Notifications";

export default function StartupNotifications() {
  return <StudentNotifications />;
}
